import React from "react";
import ReactApexChart from "react-apexcharts";
import "./style.scss";
import moment from "moment";
import { formatCurrency } from "../../../utils/helpers/string";

function StageStatistics({
  title,
  chartType = "line",
  seriesData,
  categories = [],
  colors = ["#4CB944"],
  sidebarType,
  bottomType,
  yAxisType,
}) {
  const validSeriesData = Array.isArray(seriesData)
    ? seriesData
    : [{ name: "Counts", data: [] }];
    console.log(categories,"categoriescategoriescategories")

  const options = {
    chart: {
      type: chartType,
      toolbar: {
        show: true,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: seriesData?.length > 5 ? "10%" : "50%",
        endingShape: "rounded",
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "left",
      offsetY: 10,
      offsetX: -10,
      itemMargin: {
        horizontal: 16,
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    colors: colors,
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: categories,
      title: {
        text: bottomType || "Months",
      },
      labels: {
        formatter: function (value) {
          // Convert value to a string and clean up extra spaces
          const cleanValue = value ? String(value).replace(/\s+/g, ' ').trim() : '';
          return bottomType === "Month"
            ? cleanValue
            : moment(cleanValue).format("DD.MM.YY");
        },
      },
    },
    yaxis: {
      title: {
        text: sidebarType || "Counts",
      },
      labels: {
        formatter: function (value) {
          return yAxisType === "USD" ? formatCurrency(value) : Math.round(value);
        },
      },
    },
    fill: {
      opacity: 0.3,
    },
    markers: {
      size: 5,
      strokeWidth: 2,
    },
  };

  return (
    <div className="stagestats">
      <div className="stagestats_wrapper">
        <h3 className="chart_title">{title}</h3>
        <div className="chart_wrapper">
          <div className="chartBox">
            <Chart
              options={options}
              seriesData={validSeriesData}
              chartType={chartType}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StageStatistics;

function Chart({ options, chartType, seriesData }) {
  return (
    <ReactApexChart
      options={options}
      series={seriesData}
      type={chartType}
      height={280}
    />
  );
}